import type { RouteRecordRaw } from 'vue-router'
import CommunityList from '@/views/middleGround/community/communityList.vue'
import CommunityDetail from '@/views/middleGround/community/communityDetail.vue'
import CommunityCheckedList from '@/views/middleGround/community/communityWillAuditApplyList.vue'
import CommunityApplyList from '@/views/middleGround/community/communityApplyList.vue'
import CommunityApplyDetail from '@/views/middleGround/community/communityApplyDetail.vue'
import CommunityStat from '@/views/middleGround/community/communityStat.vue'
import CommunityWillAuditApplyList from '@/views/middleGround/community/communityWillAuditApplyList.vue'
import CommunityWillAuditApplyDetail from '@/views/middleGround/community/communityWillAuditApplyDetail.vue'

// 社区营销
export const CommunityRoute: Array<RouteRecordRaw> = [
  {
    path: 'community/communityList',
    name: 'CommunityList',
    meta: {
      title: '社区营销活动-活动列表' 
    },
    component: CommunityList
  },
  {
    path: 'community/communityList/communityDetail/:id',
    name: 'CommunityDetail',
    meta: {
      title: '社区营销活动-活动详情' 
    },
    component: CommunityDetail
  },
  {
    path: 'community/communityApplyList',
    name: 'CommunityApplyList',
    meta: {
      title: '社区营销活动-待审核' 
    },
    component: CommunityApplyList
  },
  {
    path: 'community/communityApplyList/communityApplyDetail/:id',
    name: 'CommunityApplyDetail',
    meta: {
      title: '社区营销活动-报名详情' 
    },
    component: CommunityApplyDetail
  },
  {
    path: 'community/communityWillAuditApplyList',
    name: 'CommunityWillAuditApplyList',
    meta: {
      title: '招商活动-待审核报名' 
    },
    component: CommunityWillAuditApplyList
  },
  {
    path: 'community/communityWillAuditApplyList/communityWillAuditApplyDetail/:id',
    name: 'CommunityWillAuditApplyDetail',
    meta: {
      title: '招商活动-待审核报名详情' 
    },
    component: CommunityWillAuditApplyDetail
  },
  {
    path: 'community/communityStat',
    name: 'CommunityStat',
    meta: {
      title: '招商活动-统计' 
    },
    component: CommunityStat
  },
]

export default CommunityRoute